module.exports = __webpack_public_path__ + "static/img/pcmt_xiamo_ct.fb4ae31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcmt_xiamo_ct.jpg
// module id = QidK
// module chunks = 1